import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getAuthResult } from '~/stateGetter';
import { presentAuthError } from '~/statePresenter';
import { Area, Box, Card, CardText, Heading, HStack, VStack, Image } from '~/native-ui';
import { LoginForm } from '~/ui/LoginForm';
import { Center } from 'native-base';
import getConfig from '~/config';

export class AuthPage extends Component {
    static propTypes = {};

    state = {
        // backgroundProps: {
        //     // source: { uri: "http://127.0.0.1:8081/login-bg.jpg" },
        //     resizeMode: "cover",
        //     style: { minHeight: "100%", flex: "2" }
        // },
        loadedLogo: false,
        logoProps: {
            source: { uri: getConfig().guest_logo },
            resizeMode: 'contain',
            borderWidth: 2,
            style: {
                // backgroundColor: "#fff",
                // borderRadius: "50%",
                height: '100px',
            },
        },

        formProps: {
            margin: '0',
            shadow: '4',
            hasDivider: false,
            raised: true,
            bg: '#fff',
            borderRadius: '2',
            maxWidth: 400,
            space: 0,
            boxShadow: 'none',
        },
    };

    componentDidMount() {
        const logoProps = this.state.logoProps;
        const uri = logoProps.source.uri;

        const onFail = () => {
            this.setState({
                loadedLogo: true,
                marginTop: '0px',
                logoProps: {
                    ...logoProps,
                    style: {
                        ...logoProps.style,
                        height: '0',
                        marginTop: '0',
                        width: '0',
                    },
                },
            });
            console.error('Logo Loading failed');
        };

        if (!uri) {
            onFail();
            return;
        }

        Image.getSize(
            uri,
            (height, width) => {
                const ratio = 100 / height;
                height = height * ratio;
                width = width * ratio;
                height = height < 100 ? 100 : height;
                width = width < 100 ? 100 : width;

                const margin = height / 2;
                this.setState({
                    loadedLogo: true,
                    formProps: {
                        ...this.state.formProps,
                        marginTop: margin + 'px',
                    },
                    logoProps: {
                        ...logoProps,
                        style: {
                            ...logoProps.style,
                            height,
                            marginTop: -1 * margin,
                            width,
                        },
                    },
                });
            },
            onFail
        );
    }

    renderMessage() {
        let { trans, error } = this.props;

        if (!error || !error.length) {
            return (
                <VStack>
                    <Heading fontSize="2xl">{trans('loginPage.welcomeTitle')}</Heading>
                    <Box>{trans('loginPage.welcomeMessage')}</Box>
                </VStack>
            );
        }

        return (
            <VStack>
                <Heading fontSize="2xl">{trans('loginPage.loginErrorTitle')}</Heading>
                <Box>{error}</Box>
            </VStack>
        );
    }

    getLogoSize = (event) => {
        // console.log({ event, source: event.source });
    };

    renderForm() {
        if (!this.state.loadedLogo) {
            return null;
        }

        return (
            <Card {...this.state.formProps}>
                <Box px="6" zIndex="10" alignItems="center">
                    <Image {...this.state.logoProps} getSize={this.getLogoSize} />
                </Box>
                <CardText p="6" pt="2">
                    <Area mt="0">{this.renderMessage()}</Area>
                    <Area>
                        <LoginForm />
                    </Area>
                </CardText>
            </Card>
        );
    }

    render() {
        return (
            <HStack width="100%" minHeight="100%" bg="primary.500" py={8}>
                {/* <ImageBackground { ...this.state.backgroundProps } /> */}
                <Center mt="auto" mb="auto" flex="1" className="login-wrapper" h="100%">
                    {this.renderForm()}
                </Center>
            </HStack>
        );
    }
}

const RXAuthPage = connect(
    (state) => {
        return {
            authResult: getAuthResult(state),
        };
    },
    (dispatch) => ({}),
    (props) => {
        return {
            error: presentAuthError(props.authResult),
        };
    }
)(AuthPage);

export default RXAuthPage;
